import { render, staticRenderFns } from "./EmailStatus.vue?vue&type=template&id=88d5a1e0&scoped=true"
import script from "./EmailStatus.vue?vue&type=script&lang=js"
export * from "./EmailStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d5a1e0",
  null
  
)

export default component.exports